/**
 * Organizes permissions by module for the role management UI
 * Based on the permissions defined in the permissions.js file
 */

const permissionGroups = [
  {
    module: "Dashboard",
    permissions: ["show_dashboard"],
  },
  {
    module: "Products",
    permissions: [
      "show_product",
      "create_product",
      "edit_product",
      "delete_product",
      "download_product",
    ],
  },
  {
    module: "Units",
    permissions: ["show_unit", "create_unit", "edit_unit"],
  },
  {
    module: "Categories",
    permissions: ["show_category", "create_category", "edit_category"],
  },
  {
    module: "Brands",
    permissions: ["show_brand", "create_brand", "edit_brand"],
  },
  {
    module: "Customers",
    permissions: [
      "show_customer",
      "create_customer",
      "edit_customer",
      "delete_customer",
      "block_customer",
    ],
  },
  {
    module: "Customer Billing",
    permissions: ["show_customerBilling", "download_customerBilling"],
  },
  {
    module: "Customer Requests",
    permissions: [
      "show_customerRequests",
      "approve_customerRequests",
      "deny_customerRequests",
    ],
  },
  {
    module: "Locations",
    permissions: [
      "show_location",
      "create_location",
      "edit_location",
      "delete_location",
    ],
  },
  {
    module: "Receipts",
    permissions: [
      "show_receipts",
      "create_receipts",
      "edit_receipts",
      "delete_receipts",
      "download_receipts",
    ],
  },
  {
    module: "Common Vouchers",
    permissions: [
      "show_commonVouchers",
      "create_commonVouchers",
      "edit_commonVouchers",
      "delete_commonVouchers",
      "on_off_commonVouchers",
    ],
  },
  {
    module: "User Vouchers",
    permissions: [
      "show_userVouchers",
      "create_userVouchers",
      "edit_userVouchers",
      "delete_userVouchers",
      "on_off_userVouchers",
    ],
  },
  {
    module: "Posters",
    permissions: [
      "show_poster",
      "create_poster",
      "edit_poster",
      "delete_poster",
    ],
  },
  {
    module: "Outstanding Balances",
    permissions: [
      "show_outstandingBalances",
      "download All_allOutstandingBalances",
      "download Particular_particularOutstandingBalances",
    ],
  },
  {
    module: "Ledger",
    permissions: ["show_ledger", "download_ledger"],
  },
  {
    module: "GST Reports",
    permissions: ["show_gstReports", "download_gstReports"],
  },
  {
    module: "Finance",
    permissions: [
      "show _finance",
      "create_purchase",
      "edit_purchase",
      "delete_purchase",
    ],
  },
  {
    module: "Loyalty",
    permissions: [
      "show_loyalty",
      "manage_points",
      "edit_points",
      "delete_points",
      "create_redemption",
    ],
  },
  {
    module: "Employees",
    permissions: [
      "show_employee",
      "create_employee",
      "edit_employee",
      "delete_employee",
    ],
  },
  {
    module: "Roles",
    permissions: ["show_role", "create_role", "edit_role", "delete_role"],
  },
  {
    module: "Orders",
    permissions: [
      "show_order",
      "create_order",
      "edit_order",
      "delete_order",
      "accept_order",
      "generate_bill",
    ],
  },
  {
    module: "Settings",
    permissions: ["show_settings", "edit_settings"],
  },
  {
    module: "Purchase",
    permissions: [
      "show_purchase",
      "create_purchase_order",
      "edit_purchase_order",
      "delete_purchase_order",
      "create_purchase_inward",
      "edit_purchase_inward",
      "delete_purchase_inward",
      "create_purchase_return",
      "edit_purchase_return",
      "delete_purchase_return",
    ],
  },
  {
    module: "Production",
    permissions: [
      "show_production",
      "show_jobslips",
      "create_jobslip",
      "edit_jobslip",
      "delete_jobslip",
      "show_design_recipe",
      "create_design_recipe",
      "edit_design_recipe",
      "delete_design_recipe",
      "show_karigar",
      "create_karigar",
      "edit_karigar",
      "delete_karigar",
    ],
  },
];

export default permissionGroups;
